import React from 'react';
import { formatCurrencyBRL } from '../../../../../utils/utils';
import * as S from './styles';

export function Item({ product, selected }) {
  return (
    <S.Container selected={selected}>
      <S.Text>{product.Descricao}</S.Text>
      <S.Text>{formatCurrencyBRL(product?.PrecoVenda ?? 0)}</S.Text>
    </S.Container>
  );
}
